"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionDurationMs = exports.sessionDurationMin = exports.isServer = exports.isClient = void 0;
var sessionDurationMin = 20;
exports.sessionDurationMin = sessionDurationMin;
var sessionDurationMs = sessionDurationMin * 60 * 1000;
exports.sessionDurationMs = sessionDurationMs;
var isServer = typeof window === 'undefined';
exports.isServer = isServer;
var isClient = !isServer;
exports.isClient = isClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/constants.js
// module id = 697
// module chunks = 25